module.exports = __webpack_public_path__ + "static/media/hsk-logo.3d4a227e.png";